function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12 24.001c6.628 0 12.001-5.373 12.001-12 0-6.628-5.373-12.001-12-12.001C5.373 0 0 5.373 0 12c0 6.628 5.373 12.001 12 12.001z",
  fill: "#616161"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 19.637A7.636 7.636 0 014.365 12 7.636 7.636 0 0117.4 6.6l3.086-3.086A11.964 11.964 0 0012 0C5.374 0 0 5.373 0 12c0 6.628 5.373 12.001 12 12.001a11.97 11.97 0 008.487-3.514L17.4 17.4a7.623 7.623 0 01-5.4 2.236z",
  fill: "#9E9E9E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.637 12h-3.819a3.82 3.82 0 00-7.636 0c0 1.027.406 1.959 1.066 2.646l-.003.003 4.728 4.728h.001A7.639 7.639 0 0019.637 12z",
  fill: "#424242"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 12h-4.364a7.64 7.64 0 01-5.662 7.377l3.37 3.37A12 12 0 0024 12z",
  fill: "#616161"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 23.863C5.397 23.863.04 18.528.002 11.932L0 12c0 6.628 5.373 12 12 12 6.628 0 12.001-5.372 12.001-12L24 11.932c-.038 6.595-5.396 11.931-12 11.931z",
  fill: "#212121",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.975 19.377l.106.107a7.637 7.637 0 005.555-7.348V12a7.64 7.64 0 01-5.661 7.377z",
  fill: "#fff",
  fillOpacity: 0.05
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.819 10.91h-9.82a1.09 1.09 0 100 2.18h9.819a1.09 1.09 0 000-2.18z",
  fill: "#9E9E9E"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M21.819 10.91h-9.82a1.09 1.09 0 100 2.18h9.819a1.09 1.09 0 000-2.18z",
  fill: "#BDBDBD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.181 12.818a.818.818 0 100-1.636.818.818 0 000 1.636zM12 3a.818.818 0 100-1.637A.818.818 0 0012 3zM12 22.636A.818.818 0 1012 21a.818.818 0 000 1.636zM5.046 5.875a.818.818 0 100-1.636.818.818 0 000 1.636zM5.046 19.774a.818.818 0 100-1.636.818.818 0 000 1.636z",
  fill: "#BDBDBD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.955 19.774a.818.818 0 100-1.636.818.818 0 000 1.636z",
  fill: "#757575"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 11.046h9.818c.58 0 1.053.452 1.087 1.023 0-.024.004-.046.004-.07a1.09 1.09 0 00-1.091-1.09H12a1.09 1.09 0 00-1.087 1.16A1.088 1.088 0 0112 11.044z",
  fill: "#fff",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.905 12.068a1.092 1.092 0 01-1.087 1.023H12c-.58 0-1.053-.452-1.087-1.023A1.09 1.09 0 0012 13.226h9.818a1.09 1.09 0 001.087-1.158z",
  fill: "#212121",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4.501c2.109 0 4.018.855 5.4 2.237l3.153-3.155-.068-.068L17.4 6.6A7.636 7.636 0 004.364 12l.001.069A7.635 7.635 0 0112.001 4.5z",
  fill: "#212121",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 24.001c6.628 0 12.001-5.373 12.001-12 0-6.628-5.373-12.001-12-12.001C5.373 0 0 5.373 0 12c0 6.628 5.373 12.001 12 12.001z",
  fill: "url(#paint0_radial)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.52 3.492) scale(23.9595)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})));

var SvgIconGa = function SvgIconGa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconGA.3836c4fc.svg";
export { ForwardRef as ReactComponent };